import React from "react";

import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import italianAuthFooterTranslations from "../../translations/footer/auth/it.footer.auth.json";
import englishAuthFooterTranslations from "../../translations/footer/auth/en.footer.auth.json";

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianAuthFooterTranslations, "it");
    this.props.addTranslationForLanguage(englishAuthFooterTranslations, "en");
  }

  render() {
    return (
      <>
        <footer className="py-5">
          <Container>
            <Row className="align-items-center justify-content-xl-between">
              <Col xl="6">
                <div className="copyright text-center text-xl-left text-muted">
                  <Translate id="footer.auth.rights"/>
                  <a
                    className="font-weight-bold ml-1"
                    href="https://www.plick.eu"
                    target="_blank"
                  >
                    <Translate id="footer.auth.pay.do"/>
                  </a>
                </div>
              </Col>
              <Col xl="6">
                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                  <NavItem>
                    <NavLink
                      href="https://www.plick.eu"
                      target="_blank"
                    >
                      <Translate id="footer.auth.plick"/>
                    </NavLink>
                  </NavItem>
                  {/*<NavItem>*/}
                  {/*  <NavLink*/}
                  {/*    href="#"*/}
                  {/*    target="_blank"*/}
                  {/*  >*/}
                  {/*    <Translate id="footer.auth.about.us"/>*/}
                  {/*  </NavLink>*/}
                  {/*</NavItem>*/}
                </Nav>
              </Col>
            </Row>
          </Container>
        </footer>
      </>
    );
  }
}

export default withLocalize(Login);
